export const SUPPORTED_LANGUAGES = ['es', 'en', 'fr', 'de'] as const;
export const DEFAULT_LANGUAGE = 'es';
export type SupportedLanguage = typeof SUPPORTED_LANGUAGES[number];

export function isSupportedLanguage(value: string | null | undefined): value is SupportedLanguage {
  return SUPPORTED_LANGUAGES.includes(value as SupportedLanguage);
}
